<script>
import { Input } from 'ant-design-vue'
export default {
  props: ['value', 'mode'],
  render() {
    return (
      <Input.TextArea
        disabled={this.mode == 'detail'}
        value={this.value}
        style={{ minHeight: '200px' }}
        onChange={e => this.$emit('change', e.target.value)}
      />
    )
  }
}
</script>
